import { render, staticRenderFns } from "./MdMainWrap.vue?vue&type=template&id=0816321b&scoped=true&"
import script from "./MdMainWrap.vue?vue&type=script&lang=js&"
export * from "./MdMainWrap.vue?vue&type=script&lang=js&"
import style0 from "./MdMainWrap.vue?vue&type=style&index=0&id=0816321b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0816321b",
  null
  
)

export default component.exports